export const API_URL = process.env.NODE_ENV==='development'? 'https://localhost:8080':'https://api.dolsei.com';